// F1-4、F1-5
import { ISingleMediaAndTags, paddingTopClassMap, paddingBottomClassMap } from '@/common/pd-meta-components-types'
import clsx from 'clsx'
import { FC, useMemo, useRef } from 'react'
import TitleAndDesc from '../../title-and-desc'
import { useMobileDetector } from '@/hooks/use-mobile-detector'
import PdMedia from '@/components/pd-media/pd-media'
import TagItem from '@/components/standard/tag-item'
import useScrollScale from '@/hooks/tools/use-scroll-scale'

const SingleMediaAndTags: FC<ISingleMediaAndTags> = ({
  type = 'F1-5',
  theme,
  title,
  desc,
  mediaUrl = '',
  mediaH5Url = '',
  tagGroup,
  paddingTop = 'px120',
  paddingBottom = 'px120',
}) => {
  const isMobile = useMobileDetector()
  const autoHeight = type === 'F1-4'
  const mediaRef = useRef<HTMLDivElement>(null)
  const containerRef = useScrollScale({
    targetSelector: mediaRef.current,
  })

  const { tagContainerClass, titleClassName, descClassName } = useMemo(() => {
    switch (type) {
      case 'F1-5':
        return {
          tagContainerClass: 'grid grid-cols-2 laptop:grid-cols-4',
          titleClassName: 'pd-main-text',
          descClassName: 'pd-sub-text',
        }
      case 'F1-4':
      default:
        return {
          tagContainerClass: clsx('grid laptop:flex', tagGroup?.length === 1 ? 'grid-cols-1' : 'grid-cols-2'),
          titleClassName: 'pd-second-title',
          descClassName: 'pd-third-title',
        }
    }
  }, [type, tagGroup?.length])

  const contentAlign = useMemo(() => {
    switch (type) {
      case 'F1-5':
        return 'center'
      case 'F1-4':
      default:
        return 'left'
    }
  }, [type])

  return (
    <div className={clsx('w-full h-fit', paddingTopClassMap[paddingTop], paddingBottomClassMap[paddingBottom], `pd-theme-${theme}`, 'bg-container-primary')}>
      <TitleAndDesc title={title} desc={desc} />
      <div className={clsx('w-full max-w-300 mx-auto', 'px-6 laptop:px-0')}>
        <div className={clsx('w-full overflow-hidden')} style={{ aspectRatio: autoHeight ? undefined : '2/1' }} ref={containerRef}>
          <div className={clsx('w-full', !autoHeight && 'h-full', 'scale-150')} ref={mediaRef}>
            <PdMedia src={isMobile ? mediaH5Url || mediaUrl : mediaUrl} mask={false} autoHeight={autoHeight} />
          </div>
        </div>
        {!!tagGroup?.length && (
          <div className={clsx('gap-x-3 gap-y-12 laptop:gap-6 mt-8 laptop:mt-16', tagContainerClass)}>
            {tagGroup.map((tag, index) => (
              <TagItem
                key={index}
                {...tag}
                contentAlign={contentAlign}
                titleClassName={titleClassName}
                descClassName={descClassName}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
export default SingleMediaAndTags
